import styled from "styled-components";

export const StyledEditableInput = styled.input`
  border: none;
  outline: none;
  background-color: transparent;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  line-height: inherit;
  height: 100%;
  padding: 0;
  margin: 0;
  field-sizing: content;
`;

export const StyledEditableTextarea = styled.textarea`
  border: none;
  outline: none;
  background-color: transparent;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  resize: none;
`;

export const StyledTextareaCalculator = styled.div`
  visibility: hidden;
  box-sizing: border-box;
  width: ${({ width }) => width};
  height: auto;
  min-height: 1.7em;
  white-space: pre-wrap;
  word-break: break-word;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  position: absolute;
`;
